export enum LocalizationId {
    Title = "my-profile.title",
    AboutPhotoInformation = "my-profile.about_photo_information",
    AboutButtonDelete = "my-profile.about_button_delete",
    AboutTitle = "my-profile.about_title",
    AboutName = "my-profile.about_name",
    AboutBirth = "my-profile.about_date_of_birth",
    AboutRole = "my-profile.about_role",
    AboutStatus = "my-profile.about_status",
    AboutNewsLabel = "my-profile.about_news_label",
    ContactsTitle = "my-profile.contacts_title",
    ContactsEmail = "my-profile.contacts_email",
    ContactsPrimaryNumber = "my-profile.contacts_primary_number",
    ContactsPrimaryNumberHint = "my-profile.contacts_primary_number_hint",
    AddressTitle = "my-profile.address_title",
    AddressLabel = "my-profile.address_address",
    AddressCurrent = "my-profile.current_address",
    ChangesSavedSuccessfully = "my-profile.alert_success_changed",
    TextTooltipButtonPen = "my-profile.text_tooltip_button",
    PageErrorNotificationLabel = "my-profile.page_error_notification_label",
    EditRolesPlaceholder = "my-profile.edit_roles_placeholder",
    NoneLastLoginDate = "my-profile.none_last_login_date",
}

export enum EditAddressLocalizationId {
    EditAddressTitle = "my-profile.edit_address_title",
    EditAddressPrimaryButton = "my-profile.edit_address_primary_button",
    EditAddressSecondaryButton = "my-profile.edit_address_secondary_button",
}

export enum EditAboutLocalizationId {
    EditAboutTitle = "my-profile.edit_about_title",
    EditDateOfBirthOptionalLabel = "my-profile.edit_date_of_birth_optional_label",
    EditDateOfBirthAdditionalText = "my-profile.edit_date_of_birth_additional_text",
    EditPhotoInformationMaxSize = "my-profile.edit_photo_information_max_size",
    EditPhotoInformationAvailableFormats = "my-profile.edit_photo_information_available_information",
    EditDeletePhotoButton = "my-profile.edit_delete_photo_button",
    EditAboutPrimaryButton = "my-profile.edit_about_primary_button",
    EditAboutSecondaryButton = "my-profile.edit_about_secondary_button",
    EditFirstName = "my-profile.edit_first_name",
    EditLastName = "my-profile.edit_last_name",
    EditAvatarSizeError = "my-profile.edit_avatar_size_error",
    EditAvatarTooltip = "my-profile.edit_avatar_tooltip",
    ChangeEmailSavedSuccessfully = "my-profile.alert_email_successfully_changed",
}

export enum DeleteLocalizationId {
    DialogImageTitle = "my-profile.dialog_image_title",
    DialogImageDescription = "my-profile.dialog_image_description",
    DialogImagePrimaryButton = "my-profile.dialog_image_primary_button",
    DialogImageSecondaryButton = "my-profile.dialog_image_secondary_button",
}
